import { put, takeLatest, call, all } from "redux-saga/effects";
import projectsApi from "api/projects";
import purchaseOrderApi from "api/purchaseOrderApi";
import profileApi from "api/profile";
import * as actions from "../actions/projects";
import { PO_ACCEPTED_STATUS, PO_REJECTED_STATUS } from "utils/constantValues";
function* getAgencyProjects({ agencyId, query, cb }) {
  try {
    const response = yield call(projectsApi.getAgencyProjects, agencyId, query);
    yield put(actions.setAgencyProjects(response));
    cb(true);
  } catch (error) {
    cb(false, error);
    console.error("Error fetching agency projects:", error);
  }
}

function* getAssigneesPerProject({ agencyId, projectId, cb }) {
  try {
    const response = yield call(
      projectsApi.getAssigneesPerProject,
      agencyId,
      projectId
    );
    yield put(actions.setAssigneesPerProject(response));
    cb(true);
  } catch (error) {
    cb(false);
    console.error("Error fetching agency projects:", error);
  }
}
function* getVendorTasks({ vendorId, query, cb }) {
  try {
    const response = yield call(projectsApi.getVendorTasks, vendorId, query);
    yield put(actions.setVendorTasks(response));
    cb(true);
  } catch (error) {
    cb(false, error);
    console.error("Error fetching vendor tasks:", error);
  }
}

function* uploadDeliverable({ assigneeId, payload, cb }) {
  try {
    yield call(projectsApi.uploadDeliverableFile, assigneeId, payload);
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

function* downloadPoSaga({ poId, cb }) {
  try {
    const url = yield call(purchaseOrderApi.downloadPo, poId);
    window.open(url, "_blank");
    cb?.(true, url);
  } catch (error) {
    cb?.(false, error);
  }
}

function* downloadUserInvoiceSaga({ poId, cb }) {
  try {
    const url = yield call(purchaseOrderApi.downloadUserInvoice, poId);
    window.open(url, "_blank");
    cb?.(true, url);
  } catch (error) {
    cb?.(false, error);
  }
}

function* downloadParentFileSaga({ fileId, cb }) {
  try {
    const url = yield call(projectsApi.downloadParentFile, fileId);

    window.open(url, "_blank");
    cb?.(true, url);
  } catch (error) {
    cb?.(false, error);
  }
}

function* respondToPoSaga({ assigneeId, acceptance, cb }) {
  try {
    yield call(purchaseOrderApi.responseToPo, assigneeId, { acceptance });
    yield put(
      actions.updateAssigneeStatus(
        assigneeId,
        acceptance ? PO_ACCEPTED_STATUS : PO_REJECTED_STATUS
      )
    );
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

function* updatePreferredCurrencySaga({ payload, cb }) {
  try {
    yield call(profileApi.updatePreferredCurrency, payload);
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

function* updateBankDetailsCommonSaga({ payload, cb }) {
  try {
    yield call(profileApi.updateBankDetailsCommon, payload);
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

function* updateUreedCommonSaga({ payload, cb }) {
  try {
    yield call(profileApi.updateUreedCommon, payload);
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}
function* updatePayoneerCommonSaga({ payload, cb }) {
  try {
    yield call(profileApi.updatePayoneerCommon, payload);
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

function* updateCashExpressCommonSaga({ payload, cb }) {
  try {
    yield call(profileApi.updateCashExpressCommon, payload);
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

function* updateVat({ payload, cb }) {
  try {
    yield call(profileApi.updateVatCommon, payload);
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

export function* projectsSaga() {
  yield all([
    takeLatest(actions.GET_AGENCY_PROJECTS, getAgencyProjects),
    takeLatest(actions.GET_VENDOR_TASKS, getVendorTasks),
    takeLatest(actions.VM_GET_ASSIGNEE_PER_PROJECT, getAssigneesPerProject),
    takeLatest(actions.VM_UPLOAD_DELIVERABLE, uploadDeliverable),
    takeLatest(actions.VM_DOWNLOAD_PO, downloadPoSaga),
    takeLatest(actions.VM_DOWNLOAD_USER_INVOICE, downloadUserInvoiceSaga),
    takeLatest(actions.VM_DOWNLOAD_PARENT_FILE, downloadParentFileSaga),
    takeLatest(actions.VM_RESPOND_TO_PO, respondToPoSaga),
    takeLatest(
      actions.VM_UPDATE_PREFERRED_CURRENCY,
      updatePreferredCurrencySaga
    ),
    takeLatest(actions.VM_UPDATE_BANK_DETAILS, updateBankDetailsCommonSaga),
    takeLatest(actions.VM_UPDATE_UREED, updateUreedCommonSaga),
    takeLatest(actions.VM_UPDATE_PAYONEER, updatePayoneerCommonSaga),
    takeLatest(actions.VM_UPDATE_CASH_EXPRESS, updateCashExpressCommonSaga),
    takeLatest(actions.VM_UPDATE_VAT, updateVat),
  ]);
}
